import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../../utils/auth_util';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class MagazineIssuePostsModel extends Base {
  static async fetch(params, store) {
    const state = store.getState();
    // const site = get(state, 'config.site');
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const cacheExpire = get(state, 'config.cacheExpire');
    const host = get(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
    const protocol = get(state, 'config.protocol') || 'https://';
    const options = {};
    // api has auth in beta
    if (get(state, 'config.authEnabled')) {
      extend(options, authUtil(state));
    }

    const issueNumber = Number(get(params, 'tag', '').replace('issue-', ''));

    const v1Url = `${protocol}${host}/api/v1/magazine/get-magazine-posts-by-issue/${issueNumber}`;
    const v4Url = `${protocol}mvapi.fastcompany.com/v4/tag/posts/fastcompany/issue-${issueNumber}?old_fe=1`;
    const fixedV1Url = `${protocol}${host}/api/v1/magazine/get-magazine-posts-by-issue/261`;

    if (!cacheEnabled) {
      if (issueNumber > 261) {
        const [apiV4Res, apiV1Res] = await Promise.all([
          request.getAsync(v4Url, {}),
          request.getAsync(fixedV1Url, options)
        ]);

        const resp = {
          data: {
            coverStory: {},
            features: [],
            next: [],
            departments: apiV4Res?.data,
            magazineArchive: apiV1Res?.data?.magazineArchive,
            issue: apiV1Res?.data?.magazineArchive?.find(
              item => Number(item.issue) === issueNumber
            )
          }
        };

        return resp;
      }
      return request.getAsync(v1Url, options);
    }

    const getCachedRes = (cacheKey, cacheKeyUrl) =>
      cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!canUseDOM) {
          log.info(`Requesting: ${cacheKeyUrl} from model.`);
        }
        return request
          .getAsync(cacheKeyUrl, options)
          .then(function fetchSuccess(resp) {
            cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
      });

    const v1CacheKey = `${cacheNamespace}:${v1Url}`;
    const v4CacheKey = `${cacheNamespace}:${v4Url}`;
    const fixedV1CacheKey = `${cacheNamespace}:${fixedV1Url}`;

    if (issueNumber > 261) {
      const apiV4Res = await getCachedRes(v4CacheKey, v4Url);
      const apiV1Res = await getCachedRes(fixedV1CacheKey, fixedV1Url);

      const resp = {
        data: {
          coverStory: {},
          features: [],
          next: [],
          departments: apiV4Res?.data,
          magazineArchive: apiV1Res?.data?.magazineArchive,
          issue: apiV1Res?.data?.magazineArchive?.find(
            item => Number(item.issue) === issueNumber
          )
        }
      };

      return resp;
    }
    return getCachedRes(v1CacheKey, v1Url);
  }
}
